<app-dialog-header [title]="'ENGAGE.ADD_FEATURED_CONTENT.TITLE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="pt-24">
    <mat-horizontal-stepper *ngIf="shouldShowStepper; else selectionStepOnly" [linear]="true" labelPosition="bottom" #stepper>
        <mat-step [completed]="selectedContentTypeId !== null">
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.CONTENT' | translate }}</ng-template>

            <div fxLayout="column" fxLayoutGap="8px">
                <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    class="bg-zinc-50 hover:bg-gray-100 p-16 rounded-sm cursor-pointer"
                    *ngFor="let contentType of visibleContentTypes"
                    (click)="onSelectContentType(contentType)"
                >
                    <mat-icon class="mr-16 !w-[40px] !h-[40px]" [svgIcon]="contentType.svgIcon"></mat-icon>
                    <div fxLayout="column">
                        <h3 class="mt-0 mb-4 text-gray-700 font-medium">{{ contentType.title | translate }}</h3>
                        <p class="my-0 text-gray-700">{{ contentType.description | translate }}</p>
                    </div>
                </div>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>{{ 'GENERAL.LABEL.SELECTION' | translate }}</ng-template>

            <div [ngSwitch]="selectedContentTypeId" class="mt-4">
                <!-- Posting & Article -->
                <app-select-posting-page
                    *ngSwitchCase="contentTypeEnum.Posting"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    [articleId]="articleId"
                    [existingRelatedPostings]="existingRelatedPostings"
                    (closeDialog)="closeDialog($event)"
                ></app-select-posting-page>

                <app-select-posting-page
                    *ngSwitchCase="contentTypeEnum.Article"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    [articleId]="articleId"
                    [existingRelatedPostings]="existingRelatedPostings"
                    (closeDialog)="closeDialog($event)"
                ></app-select-posting-page>

                <!-- Course -->
                <app-engage-category-tree-page
                    *ngSwitchCase="contentTypeEnum.Course"
                    [audienceRelevantExperiences]="audienceRelevantExperiences"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    (closeDialog)="closeDialog($event)"
                ></app-engage-category-tree-page>

                <!-- Category -->
                <app-category-single-card-page
                    *ngSwitchCase="contentTypeEnum.Category"
                    [audienceRelevantExperiences]="audienceRelevantExperiences"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    (closeDialog)="closeDialog($event)"
                ></app-category-single-card-page>

                <!-- Live Category Link -->
                <app-live-category-link-page
                    *ngSwitchCase="contentTypeEnum.Live_Link"
                    [audienceRelevantExperiences]="audienceRelevantExperiences"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    [liveCategoryLinks]="liveCategoryLinks"
                    (closeDialog)="closeDialog($event)"
                ></app-live-category-link-page>
            </div>
        </mat-step>
    </mat-horizontal-stepper>

    <ng-template #selectionStepOnly>
        <div class="selection-step-only-container">
            <div [ngSwitch]="selectedContentTypeId" class="mt-4">
            <!-- Posting & Article -->
                <app-select-posting-page
                    *ngSwitchCase="contentTypeEnum.Posting"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    [articleId]="articleId"
                    [existingRelatedPostings]="existingRelatedPostings"
                    (closeDialog)="closeDialog($event)"
                ></app-select-posting-page>

                <app-select-posting-page
                    *ngSwitchCase="contentTypeEnum.Article"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    [articleId]="articleId"
                    [existingRelatedPostings]="existingRelatedPostings"
                    (closeDialog)="closeDialog($event)"
                ></app-select-posting-page>

                <!-- Course -->
                <app-engage-category-tree-page
                    *ngSwitchCase="contentTypeEnum.Course"
                    [audienceRelevantExperiences]="audienceRelevantExperiences"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    (closeDialog)="closeDialog($event)"
                ></app-engage-category-tree-page>

                <!-- Category -->
                <app-category-single-card-page
                    *ngSwitchCase="contentTypeEnum.Category"
                    [audienceRelevantExperiences]="audienceRelevantExperiences"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    (closeDialog)="closeDialog($event)"
                ></app-category-single-card-page>

                <!-- Live Category Link -->
                <app-live-category-link-page
                    *ngSwitchCase="contentTypeEnum.Live_Link"
                    [audienceRelevantExperiences]="audienceRelevantExperiences"
                    [featuredStreamContentId]="featuredStreamContentId"
                    [selectedContentTypeId]="selectedContentTypeId"
                    [audienceId]="audienceId"
                    [liveCategoryLinks]="liveCategoryLinks"
                    (closeDialog)="closeDialog($event)"
                ></app-live-category-link-page>
            </div>
        </div>
    </ng-template>
</div>
